<template>
  <div class="mega-text">
    uwu
  </div>
</template>
